import { render, staticRenderFns } from "./NumberInputDecimal.vue?vue&type=template&id=6bbaec60&"
import script from "./NumberInputDecimal.vue?vue&type=script&lang=js&"
export * from "./NumberInputDecimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports